export default 'À propos de Solution Éco France — CEE & énergie';
